import React from 'react';
import { Button } from '../ui/button';
import { Card, CardContent } from '../ui/card';

const MenuSaladoSection = ({ menuSalado, openLightbox, openProductDetail, getImageUrl }) => {
  if (menuSalado.length === 0) return null;

  return (
    <section id="menu-sal" className="py-20 px-6 bg-gradient-to-b from-green-50 to-cream">
      <div className="container mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-chocolate mb-4">🥗 Menú Salado</h2>
          <p className="text-lg text-chocolate-light max-w-2xl mx-auto">
            Deliciosos platos salados, empanadas y opciones para cualquier momento del día
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-4xl mx-auto">
          {menuSalado.map((item) => (
            <Card key={item.id} className="border-0 shadow-lg hover:shadow-2xl transition-all duration-300 overflow-hidden group h-full flex flex-col">
              <div 
                className="aspect-square overflow-hidden cursor-pointer relative"
                onClick={() => openLightbox(getImageUrl(item.image), item.name)}
              >
                <img 
                  src={getImageUrl(item.image)} 
                  alt={`${item.name} – Brazolovers, Quito`}
                  loading="lazy" decoding="async" className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-colors flex items-center justify-center opacity-0 group-hover:opacity-100">
                  <span className="bg-white/90 text-chocolate px-3 py-1 rounded-full text-sm font-medium">
                    🔍 Ver imagen
                  </span>
                </div>
              </div>
              <CardContent className="p-4 space-y-3 flex-grow flex flex-col">
                <h3 className="text-lg font-bold text-chocolate text-center">{item.name}</h3>
                <p className="text-xs text-chocolate-light text-center line-clamp-2">{item.description}</p>
                <div className="flex-grow"></div>
                <div className="text-center">
                  {item.hasOption && <span className="text-xs text-chocolate-light">desde </span>}
                  <span className="text-2xl font-bold text-caramel">${item.price.toFixed(2)}</span>
                </div>
                <Button 
                  onClick={() => openProductDetail(item, 'menu_sal')}
                  className="w-full bg-[#d4a574] hover:bg-[#c49564] text-white transition-colors duration-200"
                >
                  {item.hasOption && item.options && item.options.length > 0 ? 'Ver Opciones' : 'Agregar al Pedido'}
                </Button>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default MenuSaladoSection;
